import styled from "styled-components";
import {
    TextField,
} from "@material-ui/core";
import { useState } from "react";


const ModifiedProcedureSdnTitle = styled.div`
display:grid;
grid-template-columns:1fr 20px 1.5fr
width:100%;
position: relative;

`;

const TextFieldLabel = styled.div`
font-family: Roboto;
font-size: 15px;
font-weight: 500;
`

const TextFieldContainer = styled.div`
  width: 100%;
`;

const MetadataContainerStyled = styled.div`
    position: absolute;
    border-radius: 4px;
    box-shadow: 0 2px 6px 0 grey;
    background-color: #fff;
    // margin-top: 10px;
    cursor: pointer;
    min-width: 110px;
    z-index:2;
    padding: 10px;
    width:700px;
    max-height: 500px;
    overflow-y: scroll;
`
const MetadataMenuHeadingStyled = styled.div`
  display: flex;
  font-weight: 600;
`
const MetadataMenuItemProjStyled = styled.div`
  width: 15%;
`

const MetadataMenuItemSDNStyled = styled.div`
  width: 30%;
  margin: 0 0 20px 0;
`

const MetadataMenuItemRevStyled = styled.div`
  width: 12%;
`
const MetadataMenuItemTitleStyled = styled.div`
  width: 43%;
`
const MetadataItemListStyled = styled.div`
  display: flex;
`
const SdnStyled = styled.div`
  position: relative;
`

const ModifiedProcedureContainer = styled.div`
padding-top:20px;
width:100%
`;

export const DeviationForExistingProjectProcedure = (props) => {
    const { sdnValue, onSdnChange, deviationReasoning, onReasoningChange, myRRDocs, modifiedProcedureTitle, modifiedProcedureUrl } = props
    const sdnMetadata = myRRDocs

    const [newEntry, setNewEntry] = useState({
        sdn: sdnValue || '',
        name: modifiedProcedureTitle || '',
        effectiveDate: '',
        url: modifiedProcedureUrl || '',
        rev: '',
        categoryId: ''
    })

    const [metaData, setMetadata] = useState([]);
    const [isMetadataVisible, setIsMetadataVisible] = useState(false);

    const handleNewEntryChange = (e) => {
        // filter the result for metadata on sdn changed
        let temp = [];
        let isMetadataVisible = false;
        if (e.target.value.length >= 3 && sdnMetadata) {
            isMetadataVisible = true;
            temp = sdnMetadata.filter((sdnMetadataRow) => {
                // return sdnMetadataRow.sdn.includes(e.target.value) && !sdnMetadataRow.isNew; // taking too much of time
                return sdnMetadataRow.sdn.startsWith(e.target.value) && !sdnMetadataRow.isNew; // fast execution
                // return sdnMetadataRow.sdn.indexOf(e.target.value) && !sdnMetadataRow.isNew; // taking too much of time
            })
        }

        setNewEntry({
            ...newEntry, sdn: e.target.value ? e.target.value : '', name: '',
            effectiveDate: '',
            url: '',
            rev: ''
        })
        setMetadata(temp)
        setIsMetadataVisible(isMetadataVisible)

        onSdnChange({
            ...newEntry,
            sdn: '',
            name: '',
            effectiveDate: '',
            url: '',
            rev: ''
        })
    }

    const handleMetadataSelect = (id) => {
        const temp = sdnMetadata.filter((sdnMetadataRow) => {
            return sdnMetadataRow.id == id
        })

        setNewEntry({
            ...newEntry,
            sdn: temp[0].sdn,
            name: temp[0].documentTitle,
            effectiveDate: temp[0].effectiveDate,
            url: temp[0].documentLink,
            rev: temp[0].documentRevision
        })
        setIsMetadataVisible(false)
        onSdnChange({
            ...newEntry,
            sdn: temp[0].sdn,
            name: temp[0].documentTitle,
            effectiveDate: temp[0].effectiveDate,
            url: temp[0].documentLink,
            rev: temp[0].documentRevision
        })
    }

    return (
        <>
            <ModifiedProcedureContainer>
                <ModifiedProcedureSdnTitle>
                    <SdnStyled>
                        <TextField
                            label="SDN"
                            value={newEntry.sdn}
                            // onChange={onSdnChange}
                            onChange={handleNewEntryChange}
                            fullWidth
                            margin="normal"
                            variant="outlined"
                        />
                        {!!isMetadataVisible && !!metaData.length && <MetadataContainerStyled>
                            <MetadataMenuHeadingStyled>
                                {/* <MetadataMenuItemProjStyled>Project No.</MetadataMenuItemProjStyled> */}
                                <MetadataMenuItemSDNStyled>SDN</MetadataMenuItemSDNStyled>
                                <MetadataMenuItemRevStyled>Rev</MetadataMenuItemRevStyled>
                                <MetadataMenuItemTitleStyled>Title</MetadataMenuItemTitleStyled>
                                {/* <MetadataMenuItemRevStyled>Rev No</MetadataMenuItemRevStyled>
                        <MetadataMenuItemProjStyled>Effective</MetadataMenuItemProjStyled>
                        <MetadataMenuItemProjStyled>Link</MetadataMenuItemProjStyled> */}

                            </MetadataMenuHeadingStyled>
                            {metaData.map((item) => {
                                return <MetadataItemListStyled key={item.id} onClick={() => handleMetadataSelect(item.id)}>
                                    {/* <MetadataMenuItemProjStyled> {item.projectNumber}</MetadataMenuItemProjStyled> */}
                                    <MetadataMenuItemSDNStyled> {item.sdn}</MetadataMenuItemSDNStyled>
                                    <MetadataMenuItemRevStyled> {item.documentRevision}</MetadataMenuItemRevStyled>
                                    <MetadataMenuItemTitleStyled> {item.documentTitle}</MetadataMenuItemTitleStyled>
                                    {/* <MetadataMenuItemTitleStyled> {item.documentVersionNumber}</MetadataMenuItemTitleStyled>
                      <MetadataMenuItemTitleStyled> {item.effectiveDate}</MetadataMenuItemTitleStyled>
                      <MetadataMenuItemTitleStyled> {item.documentLink}</MetadataMenuItemTitleStyled> */}
                                </MetadataItemListStyled>
                            })}
                        </MetadataContainerStyled>}
                    </SdnStyled>
                    <div />
                    {newEntry.name && <TextField label="Title" value={newEntry.name} fullWidth margin="normal" variant="outlined" aria-readonly />}
                </ModifiedProcedureSdnTitle>
                {newEntry.url && <TextField label="Url"
                    value={newEntry.url}
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    aria-readonly
                />}
            </ModifiedProcedureContainer>
            <TextFieldLabel>
                Reason for deviation*
            </TextFieldLabel>
            <TextFieldContainer>
                <TextField placeholder="Start typing..." value={deviationReasoning} onChange={onReasoningChange} multiline fullWidth margin="normal" variant="outlined" />
            </TextFieldContainer>
        </>);
}